/* eslint-disable no-unused-vars */
import React, { Component, forwardRef } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import styled from 'styled-components';

import { BreakPoint, Color, FontSize } from '../../../../../asset/styles';

const StyledLabel = styled.div`
  color: ${props => (props.isActive ? Color.text.darkGray : Color.text.gray)};
  font-size: ${FontSize.medium};
  line-height: 1.6875;
  text-align: left;
  word-break: break-all;

  @media (min-width: ${BreakPoint.desktop}) {
    font-size: ${FontSize.desktop.small};
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

/**
 * {@link Inquiry} - {@link FreeTextarea} - label component
 * - 入力済みで文字色を変更するために component 化します
 * - 確認用に class に文字挿入します
 * @param {string} label text
 * @param {boolean} [isActive=false] 入力済み flag
 * @param {*} props React.props
 * @return {*} React.node
 * @constructor
 */
const FreeLabel = ({ label = '', isActive = false, ...props }) => (
  <StyledLabel
    className={`FreeLabel ${isActive ? 'isActive' : 'noActive'}`}
    isActive={isActive}
    {...props}
  >
    {label}
  </StyledLabel>
);

export default FreeLabel;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/body/free/FreeLabel.js